Ext.define('SA.HistogramProxy', {
    extend: 'Ext.util.Observable',

    firstResultPending: true,

    getRequest(modelState) {
        var request = SA.HistogramRequest.create(modelState);

        if (!request.equals(this.request)) {
            this.request = request;

            request.dispatch().then(() => {
                if (request !== this.request) {
                    return;
                }

                this.firstResultPending = false;
                this.fireEvent('result');
            });
        }

        return this.request;
    },

    isFirstResultPending() {
        return this.firstResultPending;
    }
});